import { formatChangeLogCreatedAt } from '@/lib/utils/formatChangeLogCreatedAt'

/**
 * Stock audit log `created_at` — API often sends Unix seconds; `new Date(seconds)` yields 1970.
 * Matches Angular `{{ note.created_at | date:'MM/dd/yyyy hh:mm a' }}` on Stock Logs.
 */
export function formatStockAuditTimestamp(
  value: string | number | undefined | null,
): string {
  return formatChangeLogCreatedAt(value)
}
